export { Tooltip } from '../src/Tooltip';
export type { TooltipDirection } from '../src/Tooltip';
